<child-header [title]="'Finish Transfering'" (closeEvent)="onNoClick()"></child-header>

<div mat-dialog-content>
<table style="width: 100%;">
  <tr>
    <td>
      Migration request has been submitted successfully, once it's been completed by ADOBE, it will then appear our portal.
    </td>
  </tr>
  <tr>
    <td>
      Transfer ID: 
    </td>
    <td>
      <span class="bold"> {{ data.transferId }}</span>
    </td>
  </tr>
  <tr>
    <td>
      Membership ID: 
    </td>
    <td>
      <span class="bold"> {{ data.membershipId }}</span>
    </td>
  </tr>

</table>
 
</div>
<div class="nce-dialog-action">
  <button mat-button class="button button-red button-large nce-large-button continue" 
    (click)="continue()">Ok</button>
</div>
